import { LoginConfigurationFilter } from './../../models/LoginConfigurationFilter';
import { AxiosResponse } from 'axios';
import nameof from 'ts-nameof.macro';
import { url } from 'core/helpers/string';
import { Repository } from 'core/repositories/Repository';
import kebabCase from 'lodash/kebabCase';
import { PureModelData } from 'react3l';
import { httpConfig } from 'config/http';
import { API_BASE_URL } from 'core/config';

import { API_LOGIN_CONFIGURATION_ROUTE } from 'config/api-consts';
import { LoginConfiguration } from 'models/LoginConfiguration';
import { StatusFilter } from 'models/StatusFilter';
import { Status } from 'models/Status';

export class LoginConfigurationRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.setBaseURL(url(API_BASE_URL, API_LOGIN_CONFIGURATION_ROUTE));
  }

  public count = (loginConfigurationFilter?: LoginConfigurationFilter): Promise<number> => {
    return this.http
      .post<number>(kebabCase(nameof(this.count)), loginConfigurationFilter)
      .then((response: AxiosResponse<number>) => response.data);
  };

  public list = (loginConfigurationFilter?: LoginConfigurationFilter): Promise<LoginConfiguration[]> => {
    return this.http
      .post<LoginConfiguration[]>(kebabCase(nameof(this.list)), loginConfigurationFilter)
      .then((response: AxiosResponse<LoginConfiguration[]>) => {
        return response.data?.map((loginConfiguration: PureModelData<LoginConfiguration>) =>
          LoginConfiguration.clone<LoginConfiguration>(loginConfiguration),
        );
      });
  };

  public get = (id: number | string): Promise<LoginConfiguration> => {
    return this.http
      .post<LoginConfiguration>(kebabCase(nameof(this.get)), { id })
      .then((response: AxiosResponse<LoginConfiguration>) => LoginConfiguration.clone<LoginConfiguration>(response.data));
  };


  public create = (loginConfiguration: LoginConfiguration): Promise<LoginConfiguration> => {
    return this.http
      .post<LoginConfiguration>(kebabCase(nameof(this.create)), loginConfiguration)
      .then((response: AxiosResponse<PureModelData<LoginConfiguration>>) =>
      LoginConfiguration.clone<LoginConfiguration>(response.data),
      );
  };

  public update = (loginConfiguration: LoginConfiguration): Promise<LoginConfiguration> => {
    return this.http
      .post<LoginConfiguration>(kebabCase(nameof(this.update)), loginConfiguration)
      .then((response: AxiosResponse<LoginConfiguration>) => LoginConfiguration.clone<LoginConfiguration>(response.data));
  };
  public save = (loginConfiguration: LoginConfiguration): Promise<LoginConfiguration> => {
    return loginConfiguration.id ? this.update(loginConfiguration) : this.create(loginConfiguration);
  };

    public saveImage = (
    file: File,
    params?: { [key: string]: any },
  ): Promise<string> => {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http
      .post(kebabCase(nameof(this.saveImage)), formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        params,
      })
      .then((response: AxiosResponse<string>) => response.data);
  };
  public singleListStatus = (): Promise<Status[]> => {
    return this.http
      .post<Status[]>(
        kebabCase(nameof(this.singleListStatus)),
        new StatusFilter(),
      )
      .then((response: AxiosResponse<Status[]>) => {
        return response.data.map((status: PureModelData<Status>) =>
          Status.clone<Status>(status),
        );
      });
  };

  public filterListStatus = (): Promise<Status[]> => {
    return this.http
      .post<Status[]>(
        kebabCase(nameof(this.filterListStatus)),
        new StatusFilter(),
      )
      .then((response: AxiosResponse<Status[]>) => {
        return response.data.map((status: PureModelData<Status>) =>
          Status.clone<Status>(status),
        );
      });
  };
}

export const loginConfigurationRepository: LoginConfiguration = new LoginConfigurationRepository();
